import React from "react";
import CovidVaxMap from "./components/covidvaxmap";
import ChoicePays from "./components/choicepays";
import IllPackUs from "./components/ill-pack-us";
import BLERemote from "./components/ble-remote";
import TruckTrac from "./components/trucktrac";
import DCA from "./components/dca";
import Location from "./components/location";
import Footer from "./components/footer";

class Home extends React.Component {
  render() {
    document.body.classList.remove("inner-page");
    return (
      <div>
        {/* Navbar Section*/}
        <nav className="navbar navbar-expand-lg  theme-nav fixed-top">
          <div className="container">
            <a className="navbar-brand" href={`${process.env.PUBLIC_URL}/`}>
              <img src="https://cdn.johnbernazzani.com/logo.png" alt="logo" />
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#mainmenu"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon">
                <i className="fa fa-align-justify" aria-hidden="true" />
              </span>
            </button>
            <div className="collapse navbar-collapse" id="mainmenu">
              <ul className="navbar-nav ml-auto" id="mymenu">
                <li className="nav-item ">
                  <a className="nav-link" href="#home">
                    Hello
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#location">
                    Where
                  </a>
                </li>
                <li className="nav-item dropdown">
                  <a
                    href="#projects"
                    className="nav-link dropdown-toggle"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Work
                  </a>
                  <ul className="dropdown-menu">
                    <li className="nav-item">
                      <a className="nav-link" href="#covidvaxmap">
                        CovidVaxMap
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#choicepays">
                        Choice Pays
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#ill-pack-us">
                        I'll Pack Us
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#ble-remote">
                        BLE Remote
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#trucktrac">
                        TruckTrac
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#dcadvantage">
                        DCAdvantage
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        {/* Home One Section Start */}
        <section className="theme-bg-waves" id="home">
          {/* <div className="animation-circle">
						<i></i>
						<i></i>
						<i></i>
					</div> */}
          <div className="container">
            <div className="row">
              <div className="col-12 greeting">
                <h1>Hello, world!</h1>
                <p>My name is John Bernazzani and I'm a Software Engineer!</p>
                <p>
                  I <i className="fa fa-heart" /> working with:
                </p>
                <div className="skills-container">
                  <span>JavaScript &amp; TypeScript</span>
                  <span>Flutter</span>
                  <span>React</span>
                  <span>Angular2+</span>
                  <span>Node.js</span>
                  <span>MongoDB</span>
                  <span>PostgreSQL</span>
                  <span>AWS</span>
                  <span>GitHub</span>
                  <span>Ionic</span>
                  <span>SCSS</span>
                  <span>Microservices</span>
                  <span>&nbsp;&nbsp;...&nbsp;&nbsp;</span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="home-right">
                  <img
                    src="https://cdn.johnbernazzani.com/greeting-ts.png"
                    alt="top1"
                    className="img-fluid"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="home-right">
                  <img
                    src="https://cdn.johnbernazzani.com/greeting-html.png"
                    alt="top1"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
            <div className="row contact-row">
              <div className="col-12 text-center">
                {/* <div className="section-title">
									<h2 className="text-white">Contact / Follow</h2>
									<img src="https://cdn.johnbernazzani.com/white-line.svg" alt="title-line" className="img-fluid title-line" />
								</div> */}
                <div className="social-contact-me">
                  <ul>
                    <li>
                      <a
                        href="mailto:me@johnbernazzani.com"
                        target="_top"
                        rel="noopener noreferrer"
                        dangerouslySetInnerHTML={{
                          __html:
                            '<i class="fa fa-envelope" aria-hidden="true"></i>'
                        }}
                      />
                    </li>
                    <li>
                      <a
                        href="https://linkedin.com/in/johnbernazzani"
                        target="_blank"
                        rel="noopener noreferrer"
                        dangerouslySetInnerHTML={{
                          __html:
                            '<i class="fa fa-linkedin" aria-hidden="true"></i>'
                        }}
                      />
                    </li>
                    <li>
                      <a
                        href="https://github.com/johnbernazzani"
                        target="_blank"
                        rel="noopener noreferrer"
                        dangerouslySetInnerHTML={{
                          __html:
                            '<i class="fa fa-github" aria-hidden="true"></i>'
                        }}
                      />
                    </li>
                    <li>
                      <a
                        href="https://dribbble.com/johnbernazzani"
                        target="_blank"
                        rel="noopener noreferrer"
                        dangerouslySetInnerHTML={{
                          __html:
                            '<i class="fa fa-dribbble" aria-hidden="true"></i>'
                        }}
                      />
                    </li>
                    <li>
                      <a
                        href="https://twitter.com/jbernazz"
                        target="_blank"
                        rel="noopener noreferrer"
                        dangerouslySetInnerHTML={{
                          __html:
                            '<i class="fa fa-twitter" aria-hidden="true"></i>'
                        }}
                      />
                    </li>
                    <li>
                      <a
                        href="https://instagram.com/jbernazz"
                        target="_blank"
                        rel="noopener noreferrer"
                        dangerouslySetInnerHTML={{
                          __html:
                            '<i class="fa fa-instagram" aria-hidden="true"></i>'
                        }}
                      />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Home One Section End */}

        {/* Location Component
        <Location /> */}

        {/*CovidVaxMap Component*/}
        <CovidVaxMap />

        {/*ChoicePays Component*/}
        <ChoicePays />

        {/*IllPackUs Component*/}
        <IllPackUs />

        {/*BLERemote Component*/}
        <BLERemote />

        {/*TruckTrac Component*/}
        <TruckTrac />

        {/*DCA Component*/}
        <DCA />

        {/*Footer Component*/}
        <Footer />

        {/*tap-top*/}
        <div className="tap-top">
          <div>
            <i className="fa fa-angle-up" aria-hidden="true" />
          </div>
        </div>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/home.js